import { SHARED_CALENDAR_KEY } from '../refData/calendar';
import { SharedCalendar } from '../models/calendar';

export const getSharedCalendars = (): Array<SharedCalendar> => {
  const sharedCalendars = localStorage.getItem(SHARED_CALENDAR_KEY);
  return sharedCalendars ? JSON.parse(sharedCalendars) : [];
};
